<template>
  <div>
    <!-- 文件表格 -->
    <!--        {{fileList}}-->
    <el-table :data="filteredFileList" style="width: 100%" @selection-change="handleSelectionChange" :loading="loading">
      <el-table-column type="selection" width="55" align="center"></el-table-column>

      <!-- 名称列 -->
      <el-table-column align="left" label="名称"  min-width="140" show-overflow-tooltip>

        <template slot="header" slot-scope="scope">
          <span>名称</span>
          <el-input
              style="margin-left: 5px; width: calc(100% - 40px);"
              v-model="queryForm.fileName"
              size="mini"
              clearable
              placeholder="搜索文件名"/>
        </template>

        <template slot-scope="scope">
          <div @click="previewFile(scope.row,fileList)"
               style="display: flex; align-items: center; cursor: pointer;">
            <el-image v-if="isImage(scope.row.ossUrl)" :src="require('@/assets/images/i_img.png')"
                      fit="cover"/>
            <el-image v-else-if="isPdf(scope.row.ossUrl)" :src="require('@/assets/images/pdf.png')"
                      fit="cover"></el-image>
            <el-image v-else-if="isZip(scope.row.fileName)" :src="require('@/assets/images/zip.png')"
                      fit="cover"/>
            <el-image v-else-if="isPpt(scope.row.ossUrl)" :src="require('@/assets/images/ppt.png')"
                      fit="cover"/>
            <el-image v-else-if="isDoc(scope.row.ossUrl)" :src="require('@/assets/images/doc.png')"
                      fit="cover"/>
            <el-image v-else-if="isXls(scope.row.ossUrl)" :src="require('@/assets/images/xls.png')"
                      fit="cover"/>
            <el-image v-else :src="require('@/assets/images/i_file.svg')" fit="cover"/>
            {{ scope.row.fileName }}
          </div>
        </template>
      </el-table-column>

      <!-- 审核状态 -->
      <el-table-column  align="center" label="文件审核状态" width="120">
        <template slot-scope="scope">
          <el-tag
              :size="'mini'"
              :type="getAuditTagType(scope.row.auditStatus)"
              v-if="getAuditTagText(scope.row.auditStatus)"
          >
            {{ getAuditTagText(scope.row.auditStatus) }}
          </el-tag>

        </template>
      </el-table-column>

      <el-table-column prop="examineMessage" label="驳回原因" min-width="100" show-overflow-tooltip></el-table-column>

      <!-- 审核时间 -->
      <el-table-column align="center" label="审核时间" prop="examineTime"  width="250" :sort-method="sortByTime">
        <template slot-scope="scope">
          <div v-if="scope.row.examineTime || scope.row.auditorName" class="audit-info">
               <span v-if="scope.row.examineTime" class="audit-time">
                     {{ $moment(scope.row.examineTime).format('YYYY-MM-DD HH:mm') }}
               </span>
            <span v-if="scope.row.examineTime && scope.row.auditorName" class="divider">｜</span>
            <span v-if="scope.row.auditorName" class="audit-name">  {{ scope.row.auditorName }} </span>
          </div>


        </template>
      </el-table-column>


      <el-table-column align="center" label="上传时间" prop="createTime" sortable  width="160">
        <template slot-scope="scope">
          <span>
<!--           {{scope.row.createTime}}-->
            {{ $moment(scope.row.createTime).format('l') }}
            {{ $moment(scope.row.createTime).format('LTS') }}

          </span>

        </template>
      </el-table-column>

      <!-- 修改时间 -->
      <!--            <el-table-column align="center" label="修改时间">-->
      <!--                <template slot-scope="scope">-->
      <!--                    {{ $moment(scope.row.updateTime).format('l') }}-->
      <!--                    {{ $moment(scope.row.updateTime).format('LTS') }}-->
      <!--                </template>-->
      <!--            </el-table-column>-->

      <!-- 文件大小 -->
      <el-table-column prop="fileSize"  width="90" align="center" label="文件大小">
        <template slot-scope="scope">
          {{ scope.row.fileSize ? `${(scope.row.fileSize / 1024 / 1024).toFixed(2)} MB` : '0 MB' }}
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <el-button
              v-if="scope.row.type === 'FOLDER'"
              type="text"
              @click="$emit('upload-target', scope.row)"
          >去上传
          </el-button
          >

          <!--                    <el-button type="text" @click="$emit('delete', scope.row)">删除</el-button>-->
          <el-button type="text" v-if="showApplyBtn" @click="$emit('annotate', scope.row)">审核</el-button>
          <el-button type="text" @click="$emit('download', scope.row)">下载</el-button>
          <el-button
              v-if="scope.row.type === 'FOLDER'"
              type="text"
              @click="$emit('edit-folder', scope.row)"
          >编辑
          </el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--        &lt;!&ndash; 分页 &ndash;&gt;-->
    <!--        <el-pagination-->
    <!--            :disabled="loading"-->
    <!--            @size-change="$emit('size-change', $event)"-->
    <!--            @current-change="$emit('current-change', $event)"-->
    <!--            :current-page="currentPage"-->
    <!--            :page-sizes="[10, 20, 50, 100]"-->
    <!--            :page-size="pageSize"-->
    <!--            layout="total, sizes, prev, pager, next, jumper"-->
    <!--            :total="total"-->
    <!--            background-->
    <!--            style="margin-top: 20px; justify-content: flex-end"-->
    <!--        >-->
    <!--        </el-pagination>-->


    <!-- PDF等文件预览弹窗 -->
    <file-preview ref="childPreview" :visible.sync="fileShow" :url="fileUrl" :options="files"
                  @preview-close="onPreviewClose"/>


  </div>
</template>

<script>
import FilePreview from "@/components/FileView/FilePreview.vue";

export default {
  name: 'FileTable',
  components: {FilePreview},
  computed: {
    filteredFileList() {
      const keyword = this.queryForm.fileName.trim();
      if (!keyword) {
        return this.fileList; // 没有搜索时，显示全部
      }
      // 过滤：文件名包含关键字（不区分大小写）
      return this.fileList.filter(item =>
          item.fileName.toLowerCase().includes(keyword.toLowerCase())
      );
    }
  },

  data() {
    return {
      filteredList: [],       // 过滤后的数据（不要直接用这个）
      queryForm: {
        fileName: "",
      },
      fileShow: false,
      fileUrl: '',
      checkRow: '',
      files: [],
    }
  },

  props: {
    // 由父组件传入的数据
    fileList: {
      type: Array,
      required: true,
      default: () => [],
    },

    showApplyBtn: {
      type: Boolean,
      default: false,
    },

    total: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onPreviewClose() {
      console.log("返回")
      this.fileUrl = ''
    },

    // 获取文件类型
    fileType(url) {
      const type = url.split('.').pop().split('?')[0].toLowerCase();
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(type)) return 'image';
      if (type === 'pdf') return 'pdf';
      if (['doc', 'docx'].includes(type)) return 'doc';
      if (['xls', 'xlsx'].includes(type)) return 'xls';
      if (['ppt', 'pptx'].includes(type)) return 'ppt';
      return false;
    },
    // // 表格行点击
    // tableCellClick(row) {
    //     this.$emit('cell-click', row);
    // },
    // 批量选择
    handleSelectionChange(val) {
      this.$emit('selection-change', val);
    },


    // 预览单个文件
    previewFile(file, files) {
      // console.log(file)
      // console.log(files)
      // 重写 this.files 为只包含 oss URL 的数组
      this.files = files.map(file => ({
        url: file.ossUrl,
        fileName: file.fileName
      }));
      this.checkRow = file;
      this.fileShow = true;
      this.fileUrl = file.ossUrl;
      this.$refs.childPreview.openModal()

    },

    getAuditTagText(status) {
      const map = {
        0: '待审核',
        1: '初审通过',
        2: '初审驳回',
        5: '财务通过',
        6: '财务驳回',
        7: '采购通过',
        8: '采购驳回'
      };
      return map[status] || null;
    },
    getAuditTagType(status) {
      if (status === 0) return 'warning'; // 待审核 → 橙色更醒目
      if ([1, 5, 7].includes(status)) return 'success';
      if ([2, 6, 8].includes(status)) return 'danger';
      return 'info';
    },
    // 获取文件类型
    FileType(url) {
      console.log("先查看是否pdf（FileType）" + url)
      // let type = url.split('?')[0].split('.').pop().toLowerCase();
      let type = url.split('?')[0]
      if (this.isImage(type)) {
        return 'image'
      } else if (this.isPdf(type)) {
        console.log('pdf')
        return 'pdf'
      } else if (this.isDoc(type)) {
        return 'doc'
      } else if (this.isXls(type)) {
        return 'xls'
      } else if (this.isPpt(type)) {
        return 'ppt'
      } else if (this.isZip(type)) {
        return 'zip'
      } else if (this.isVideo(type)) {
        return 'video'
      } else {
        return false
      }
    },
    isVideo(filename) {
      let extension = '';
      // 判断一个字符串中是否包含“?”字符
      if (filename.includes('?')) {
        extension = filename.split('?')[0].split('.').pop().toLowerCase();
      } else {
        extension = filename.split('.').pop().toLowerCase();
      }
      const imageExtensions = ['mp4']
      return imageExtensions.includes(extension)
    },
    isImage(filename) {
      let extension = '';
      // 判断一个字符串中是否包含“?”字符
      if (filename.includes('?')) {
        extension = filename.split('?')[0].split('.').pop().toLowerCase();
      } else {
        extension = filename.split('.').pop().toLowerCase();
      }
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    isFile(filename) {
      let extension = '';
      // 判断一个字符串中是否包含“?”字符
      if (filename.includes('?')) {
        extension = filename.split('?')[0].split('.').pop().toLowerCase();
      } else {
        extension = filename.split('.').pop().toLowerCase();
      }
      const imageExtensions = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']
      return imageExtensions.includes(extension)
    },
    isDoc(filename) {
      let extension = '';
      // 判断一个字符串中是否包含“?”字符
      if (filename.includes('?')) {
        extension = filename.split('?')[0].split('.').pop().toLowerCase();
      } else {
        extension = filename.split('.').pop().toLowerCase();
      }
      const imageExtensions = ['doc', 'docx']
      return imageExtensions.includes(extension)
    },
    isXls(filename) {
      let extension = '';
      // 判断一个字符串中是否包含“?”字符
      if (filename.includes('?')) {
        extension = filename.split('?')[0].split('.').pop().toLowerCase();
      } else {
        extension = filename.split('.').pop().toLowerCase();
      }
      const imageExtensions = ['xls', 'xlsx']
      return imageExtensions.includes(extension)
    },
    isPpt(filename) {
      let extension = '';
      // 判断一个字符串中是否包含“?”字符
      if (filename.includes('?')) {
        extension = filename.split('?')[0].split('.').pop().toLowerCase();
      } else {
        extension = filename.split('.').pop().toLowerCase();
      }
      const imageExtensions = ['ppt', 'pptx']
      return imageExtensions.includes(extension)
    },
    isPdf(filename) {
      let extension = '';
      // 判断一个字符串中是否包含“?”字符
      if (filename.includes('?')) {
        extension = filename.split('?')[0].split('.').pop().toLowerCase();
      } else {
        extension = filename.split('.').pop().toLowerCase();
      }
      const imageExtensions = ['pdf']
      console.log("是否pdf " + imageExtensions.includes(extension))
      return imageExtensions.includes(extension)
    },
    isZip(filename) {
      let extension = '';
      // 判断一个字符串中是否包含“?”字符
      if (filename.includes('?')) {
        extension = filename.split('?')[0].split('.').pop().toLowerCase();
      } else {
        extension = filename.split('.').pop().toLowerCase();
      }
      const imageExtensions = ['zip', 'rar', '7z', 'tar']
      return imageExtensions.includes(extension)
    },
    sortByTime(a, b) {
      const timeA = a.createTime;
      const timeB = b.createTime;

      // 情况1：两个都为空 → 相等
      if (!timeA && !timeB) return 0;

      // 情况2：a 为空，b 有值 → a 排在后面（如果你想空值在底部）
      if (!timeA) return 1;

      // 情况3：b 为空，a 有值 → b 排在后面
      if (!timeB) return -1;

      // 情况4：都有值 → 正常时间排序
      const dateA = new Date(timeA).getTime();
      const dateB = new Date(timeB).getTime();
      return dateA - dateB; // 升序：早的在前；降序：return dateB - dateA
    }
  },
};
</script>

<style scoped>
.audit-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px; /* 更现代的间距控制 */
  font-size: 13px;
  color: #606266;
  line-height: 1.4;
}

.audit-time {
  color: #909399;
}

.audit-name {
  color: #409eff; /* 或用品牌色，突出审核人 */
  font-weight: 500;
}

.divider {
  color: #c0c4cc;
  margin: 0 2px;
}
</style>
